import { render } from "./rough.vue?vue&type=template&id=647e7e08"
import script from "./rough.vue?vue&type=script&lang=js"
export * from "./rough.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__